import React from 'react'
import gql from 'graphql-tag'
import { graphql } from 'react-apollo'
import { Link } from 'react-router-dom'
import { Button, Hairline } from 'elements'
import { ArrowRight } from 'core/icons'
import tulkojumi from 'utils/tulkojumi'
import pathWithRewrite from 'utils/pathWithRewrite'
import {
  StyledSearchResults,
  StyledFooter
} from './styled'

const SearchQuery = gql`
  query SearchQuery($lang: String!, $text: String!, $page: Int, $perpage: Int) {
    search(lang: $lang, text: $text, page: $page, perpage: $perpage) {
      total
      posts {
        path
        title
        post_type
        rewrite_url
        rewrite_source
        rewrite_target
      }
    }
    teksti(lang: $lang, _id: [
        "liepajniekiem",
        "uznemejiem",
        "dome",
        "raksti",
        "jaunumi",
        "aktuali",
        "video",
        "dokumenti",
        "iepirkumi",
        "kontakti",
        "pilsetas_attistibas_projekti",
        "skatit_visus_rezultatus",
        "skatit_detalizetus_rezultatus",
        "rezultati_nav_atrasti_",
        "nodoklu_zinojumi"
      ]) {
        _id
        text
      }
  }
`

class SearchResults extends React.PureComponent {
  constructor(props) {
    super(props)
    this._onClick = this._onClick.bind(this)
  }

  _markQuery = text => {
    const {
      query
    } = this.props

    const pattern = new RegExp(query, 'gi')
    return text.replace(pattern, match => `<strong>${match}</strong>`)
  }

  _mapPostTypeToName = (postType, teksti) => {
    switch (postType) {
      case 'LiepajniekiemPost':
        return tulkojumi(teksti, 'liepajniekiem')
      case 'UznemejiemPost':
        return tulkojumi(teksti, 'uznemejiem')
      case 'Dome':
        return tulkojumi(teksti, 'dome')
      case 'Page':
        return tulkojumi(teksti, 'raksti')
      case 'Post':
        return tulkojumi(teksti, 'jaunumi')
      case 'Aktuali':
        return tulkojumi(teksti, 'aktuali')
      case 'Video':
        return tulkojumi(teksti, 'video')
      case 'Dokumenti':
        return tulkojumi(teksti, 'dokumenti')
      case 'Iepirkumi':
        return tulkojumi(teksti, 'iepirkumi')
      case 'PasvaldibasKontakti':
        return tulkojumi(teksti, 'kontakti')
      case 'Projekti':
        return tulkojumi(teksti, 'pilsetas_attistibas_projekti')
      case 'NodokluZinojumi':
        return tulkojumi(teksti, 'nodoklu_zinojumi')
      default:
        return postType
    }
  }

  componentDidUpdate() {
    if (!this._resultsContainer) {
      return
    }

    const { data } = this.props

    if (data && data.search) {
      const { posts } = data.search
      if (posts && posts.length > 0) {
        const resultsRect = this._resultsContainer.getBoundingClientRect()
        const vh = Math.max(document.documentElement.clientHeight, window.innerHeight || 0)
        const resultsRectOverflow = (resultsRect.top + resultsRect.height) - vh
        if (resultsRectOverflow > 0) {
          const resultsFitHeight = Math.floor(resultsRect.height - resultsRectOverflow)
          this._resultsContainer.setAttribute('style', `
            max-height: ${resultsFitHeight}px;
            overflow-y: auto;
          `)
        } else {
          this._resultsContainer.setAttribute('style', '')
        }
      }
    }
  }

  _onClick = (event) => {
    if (this._resultsContainer) {
      const target = event.currentTarget
      if (!this._resultsContainer.contains(target)) {
        this.props.onClose && this.props.onClose()
      }
    }
  }

  componentDidMount() {
    document.body.addEventListener('click', this._onClick)
  }

  componentWillUnmount() {
    document.body.removeEventListener('click', this._onClick)
  }

  render() {
    const {
      lang,
      query,
      onSubmit,
      onClose,
      show,
      data,
      history,
    } = this.props

    if (!data || data.loading) {
      return null
    }

    const {
      search: { posts, total },
      teksti
    } = data

    return posts && posts.length > 0 ? (
      <StyledSearchResults show={show} innerRef={c => this._resultsContainer = c}>
        <ul>
          {
            posts.map((post, i) => {
              const rewrite = pathWithRewrite(post)

              let LinkComponent = 'a'
              let rewriteProps = {}
              if (rewrite.location.startsWith('http')) {
                rewriteProps = {
                  href: rewrite.location,
                  target: rewrite.target
                }
              }

              return (
                <li key={i}>
                  <LinkComponent {...rewriteProps}
                    onClick={() => {
                      window.gtag && gtag('event', 'search', {
                        search_term: query
                      })
                      history.push({
                        pathname: rewrite.location,
                        search: `q=${query}`,
                      })
                      onClose && onClose()
                    }}>
                    <p dangerouslySetInnerHTML={{ __html: this._markQuery(post.title) }} />
                    <small>{this._mapPostTypeToName(post.post_type, teksti)}</small>
                  </LinkComponent>
                </li>
              )
            })
          }
        </ul>
        {
          total > 0 && (
            <StyledFooter>
              <Hairline />
              <Button
                tabIndex='-1'
                icon={ArrowRight}
                iconSize='small'
                label={`${tulkojumi(teksti, 'skatit_detalizetus_rezultatus')} (${total})`}
                type='text'
                onClick={() => {
                  onSubmit && onSubmit()
                }} />
            </StyledFooter>
          )
        }
      </StyledSearchResults>
    ) : (
        <StyledSearchResults show={show} innerRef={c => this._resultsContainer = c}>
          <p>{tulkojumi(teksti, 'rezultati_nav_atrasti_')}</p>
        </StyledSearchResults>
    )
  }
}

const SearchResultsWithData = graphql(SearchQuery, {
  skip: ownProps => !ownProps.query || ownProps.query.length < 3,
  options: ({ lang, query }) => ({
    variables: {
      lang: lang || 'lv',
      text: query,
      page: 0,
      perpage: 4
    }
  })
})(SearchResults)

export default SearchResultsWithData



// WEBPACK FOOTER //
// ./src/modules/Header/components/Search/components/SearchResults/SearchResults.jsx